import {NgModule} from '@angular/core';
import {OrganizationProfileComponent} from './organization-profile/organization-profile.component';
import {LaboratoryFormComponent} from './laboratory-form/laboratory-form.component';
import {AddressFieldsModule} from '@subforms/address-fields/address-fields.module';
import {LayoutComponent} from './layout/layout.component';
import {SharedModule} from '@helpers/modules/shared.module';
import { OrganizationResolverService } from './services/organization-resolver.service';
import { OrganizationService } from './services/organization.service';
import { LabsResolverService } from './services/labs-resolver.service';
import {DirectivesModule} from '@helpers/directives/directives.module';
import {FormHelperService} from '@services/form-helper.service';
import {BankFieldsModule} from '@subforms/bank-fields/bank-fields.module';
import {LayoutModule} from '@layoutComponents/layout.module';
import {FilesUploaderModule} from '@components/files-uploader/files-uploader.module';
import {LaboratoryDocumentsModule} from '@components/laboratory-documents/laboratory-documents.module';
import {UsersModule} from './users/users.module';
import {SpecialistsModule} from '@modules/specialists/specialists.module';
import {IconsModule} from '@lab365/icons';
import { ResponsibleStaffComponent } from './components/responsible-staff/responsible-staff.component';

@NgModule({
    imports: [
        SharedModule,
        AddressFieldsModule,
        DirectivesModule,
        BankFieldsModule,
        LayoutModule,
        FilesUploaderModule,
        LaboratoryDocumentsModule,
        UsersModule,
        SpecialistsModule,
        IconsModule,
    ],
    exports: [],
    declarations: [
        LayoutComponent,
        OrganizationProfileComponent,
        LaboratoryFormComponent,
        ResponsibleStaffComponent
    ],
    providers: [
        OrganizationService,
        OrganizationResolverService,
        LabsResolverService,
        FormHelperService
    ],
})
export class OrganizationModule {
}
